import { render, staticRenderFns } from "./whatsapp-users-index.vue?vue&type=template&id=62c028dc"
import script from "./whatsapp-users-index.vue?vue&type=script&lang=js"
export * from "./whatsapp-users-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports